import { Component, ElementRef, input, viewChild } from '@angular/core';
import { EventResizeHandleAlignment } from './event-resize-handle-alignment';
import { handleDragIcon } from '@progress/kendo-svg-icons';
import { ResizeHandlePlannerEvent } from '../../../utils/absence-planner.constants';
import { AbsencePlannerEventModel } from '../../../../../core/models/absence-planner/absence-planner-event.model';

@Component({
  selector: 'app-event-resize-handle',
  templateUrl: './event-resize-handle.component.html',
  styleUrl: './event-resize-handle.component.scss',
  standalone: false,
})
export class EventResizeHandleComponent {
  public alignment = input.required<EventResizeHandleAlignment>();
  public dragHandle = viewChild<ElementRef<HTMLDivElement>>('dragHandle');
  public plannerEventModel = input.required<AbsencePlannerEventModel>();
  public readonly EventDragHandleAlignment = EventResizeHandleAlignment;
  public readonly handleDragIcon = handleDragIcon;
  public readonly ResizeHandle = ResizeHandlePlannerEvent;
}
